import { render, staticRenderFns } from "./ShuZiFanPaiQi.vue?vue&type=template&id=2163a447&scoped=true&"
import script from "./ShuZiFanPaiQi.vue?vue&type=script&lang=js&"
export * from "./ShuZiFanPaiQi.vue?vue&type=script&lang=js&"
import style0 from "./ShuZiFanPaiQi.vue?vue&type=style&index=0&id=2163a447&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2163a447",
  null
  
)

export default component.exports